import _classCallCheck from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/makeschool-com-marketing/makeschool-com-marketing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Config from "./BaseConfig";
import { ALLOWED_URL_CONFIG } from "../internal/internalConstants";

var URLConfig = /*#__PURE__*/function (_Config) {
  _inherits(URLConfig, _Config);

  var _super = _createSuper(URLConfig);

  /**
   * @param {IURLConfig} userURLConfig
   */
  function URLConfig(userURLConfig) {
    var _this;

    _classCallCheck(this, URLConfig);

    _this = _super.call(this);

    var urlConfig = _this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);

    Object.assign(_assertThisInitialized(_this), {
      secure: true
    }, urlConfig);
    return _this;
  }

  _createClass(URLConfig, [{
    key: "extend",
    value: function extend(userURLConfig) {
      var urlConfig = this.filterOutNonSupportedKeys(userURLConfig, ALLOWED_URL_CONFIG);
      return new URLConfig(Object.assign({}, this, urlConfig));
    }
    /**
     * @param {string} value Sets the cname
     */

  }, {
    key: "setCname",
    value: function setCname(value) {
      this.cname = value;
      return this;
    }
    /**
     * @param {string} value Sets the secureDistribution
     */

  }, {
    key: "setSecureDistribution",
    value: function setSecureDistribution(value) {
      this.secureDistribution = value;
      return this;
    }
    /**
     * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
     */

  }, {
    key: "setPrivateCdn",
    value: function setPrivateCdn(value) {
      this.privateCdn = value;
      return this;
    }
    /**
     * @param value Sets whether or not to sign the URL
     */

  }, {
    key: "setSignUrl",
    value: function setSignUrl(value) {
      this.signUrl = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a long signature
     */

  }, {
    key: "setLongUrlSignature",
    value: function setLongUrlSignature(value) {
      this.longUrlSignature = value;
      return this;
    }
    /**
     * @param value Sets whether or not to shorten the URL
     */

  }, {
    key: "setShorten",
    value: function setShorten(value) {
      this.shorten = value;
      return this;
    }
    /**
     * @param value Sets whether or not to use a root path
     */

  }, {
    key: "setUseRootPath",
    value: function setUseRootPath(value) {
      this.useRootPath = value;
      return this;
    }
    /**
     * @param value Sets whether or not to deliver the asset through https
     */

  }, {
    key: "setSecure",
    value: function setSecure(value) {
      this.secure = value;
      return this;
    }
    /**
     * @param value Sets whether to force a version in the URL
     */

  }, {
    key: "setForceVersion",
    value: function setForceVersion(value) {
      this.forceVersion = value;
      return this;
    }
  }]);

  return URLConfig;
}(Config);

export default URLConfig;